import React, { useEffect, useState } from 'react'
import "./NewsAndAnnouncementDetail.scoped.scss"

const ItemInformation = ({ listId, activeTab, announcement, news, imageDefault }) => {


  return (
    <div className="item-information-card">
      <div className="card-content">
        {activeTab !== 'news' && (
          <div className="left-section">
            <div className="image-container">
              <img
                src={
                  imageDefault.includes(news.find((x) => x.Id === listId)?.IconUrl) ?
                    `/img/vendors/news/${news.find((x) => x.Id === listId)?.IconUrl}.jpg`
                    : `api/Announcement/Image/${news.find((x) => x.Id === listId)?.IconUrl}`
                }
                alt={activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Topic || '' : news.find((x) => x.Id === listId)?.Topic}
                className="main-image"
              />
            </div>
          </div>
        )}

        <div className="right-section">
          <h2 className="main-title">{activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Topic || '' : news.find((x) => x.Id === listId)?.Topic}</h2>
          <div className="description-content">
            <p className='danger-html' dangerouslySetInnerHTML={{ __html: activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Detail || '' : news.find((x) => x.Id === listId)?.Detail }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemInformation